import original from 'node-time-ago';

export const timeago = (...args) => original(...args);